import CacheProvider from "../../../Shared/cache/cacheProvider";
import { LoadingProvider } from "../../../Shared/cache/context/LoadingProvider";
import { LanguageProvider } from "../../../Shared/cache/context/LanguageProvider";
import { ConfigAndTranslationProvider } from "../../../FTTX/context/ConfigAndTranslationContext";
import { ToastProvider } from "../../../Shared/Components/Toast";

const AppProvider = ({ children }) => {

  return (
    <LanguageProvider>
      <LoadingProvider>
        <CacheProvider>
          <ConfigAndTranslationProvider>
            <ToastProvider>
              {children}
            </ToastProvider>
          </ConfigAndTranslationProvider>
        </CacheProvider>
      </LoadingProvider>
    </LanguageProvider>
  );
}

export default AppProvider